import 'css/src/components/common/video-preview/MuteToggle';

import React, { useCallback } from 'react';

type MuteToggleProps = {
    muted: boolean;
    toggleMute: (muted: boolean) => void;
};

const MuteToggle = React.memo(function MuteToggle({ muted, toggleMute }: MuteToggleProps) {
    const onClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();

            toggleMute(!muted);
        },
        [muted, toggleMute],
    );

    const muteIconClass = muted ? 'volume_off' : 'volume_up';
    return (
        <div className="mute-toggle">
            <a href="#" onClick={onClick}>
                <i className="material-symbols-outlined">{muteIconClass}</i>
            </a>
        </div>
    );
});

export default MuteToggle;
